import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M103.57 75.09c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#D8FFFF"
      d="M86.57 26.14a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M6.57 53.02a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      d="m12.19 81.57 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM108.57 40.73H103v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5H100v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M57.96 26.54a30.3 30.3 0 0 0-26.53 15.57 30.32 30.32 0 0 0 .75 30.75l-6.61 13.89c-.77 1.61.92 3.29 2.53 2.53l13.89-6.62c12.89 8.02 30.1 5.41 39.99-7.12 4.86-6.15 7.12-14.1 6.23-21.89-1.81-15.86-15.06-27.14-30.25-27.11"
    />
    <path
      fill="#001A43"
      d="M58.19 65.98c-1.24 0-2.25-1.01-2.25-2.25v-6.52c0-1.24 1.01-2.25 2.25-2.25 3.2 0 5.8-2.6 5.8-5.8a5.796 5.796 0 0 0-11.59 0c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25c0-5.68 4.62-10.29 10.29-10.29s10.3 4.62 10.3 10.29c0 4.9-3.45 9.02-8.05 10.05v4.52c0 1.24-1.01 2.25-2.25 2.25M58.19 74.89a2.9 2.9 0 1 0 0-5.8 2.9 2.9 0 0 0 0 5.8"
    />
  </svg>
);
const SvgEnrichedIconRfIsBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconRfIsBrand);
export default Memo;
